import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Pipe({
    name: 'eDateSecondTime'
})
export class EDateSecondTimePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(value: any, isFromNow = false): string | null {
        if (!value) {
            return null;
        }
        if (!isFromNow) {
            return moment.unix(value).format(this.translateService.instant('common.moment_date_format'));
        } else {
            return moment.unix(value).fromNow();
        }
    }
}
